import React from 'react';

import {ListItemViewModel} from "../../../infrastructure/models/list-item.view-model";
import {ACTION_TYPES} from "../../../core/consts";
import {BoxScoresWidgetTabs} from "./box-scores-widget-tabs";
import {BoxScoresWidgetTables} from "./box-scores-widget.tables";
import {observer} from "mobx-react";
import {BoxScoresWidgetPlayersLists} from "./box-scores-widget.players-lists";
import {BoxScoresWidgetPlayerCard} from "./box-scores-widget.player-card";
import classnames from "classnames";
import styles from "../styles/box-scores-widget.module.scss";

export const BoxScoresWidgetContent = observer(({controller}) => {
  const {state} = controller;
  const {device, terms, selectedTeam} = state;
  const {isSmallView} = device;

  const tabsProps = {
    controller,
    onTabChange: (e, tab: ListItemViewModel) => controller.action(ACTION_TYPES.tabChange, {index: tab.index}),
  }

  const playersListProps = {
    controller,
    missingTitle: terms.LINEUPS_MISSING,
    missingList: selectedTeam.missingMembers,
    doubtfulTitle: state.doubtfulTitle,
    doubtfulList: selectedTeam.doubtfulMembers,
    willNotPlayTitle: terms.LINEUPS_WILL_NOT_PLAY,
    willNotPlayList: selectedTeam.willNotPlayMembers,
    showMissingSection: state.showMissingSection,
    showDoubtfulSection: state.showDoubtfulSection,
    showWillNotPlaySection: state.showWillNotPlaySection,
    isSmallView: device.isSmallView
  }

  return (
    <div className={classnames(styles.container, {[styles.small_view]: isSmallView})}>
      <BoxScoresWidgetTabs {...tabsProps}/>
      {
        selectedTeam.hasLineups ?
          <>
            <BoxScoresWidgetTables controller={controller}/>
            <BoxScoresWidgetPlayersLists {...playersListProps}/>
          </>
          :
          <div className={classnames(styles.content_empty_state)}>
            {terms.LINEUPS_EMPTY}
          </div>
      }
      <BoxScoresWidgetPlayerCard controller={controller}/>
    </div>
  )
});
